import React, { Component, useState } from "react";
import Title from "../../ComponentsPedidos/Title";
import ButtonContinue from "../../ComponentsPedidos/ButtonContinue";
import TitleWithControl from "../../ComponentsPedidos/TitleWithControl";
import ButtonEdit from "../../ComponentsPedidos/ButtonEdit";
import {
  RequestApprovalContainer,
  RequestApprovalContainerContent,
  RequestApprovalContainerContentCard,
  RequestApprovalContainerContentCardConfigProducts,
  RequestApprovalContainerContentCardConfigProductsContent,
  RequestApprovalContainerContentCardProducts,
  RequestApprovalContainerContentCardProductsContainer,
  RequestApprovalContainerContentCardProductsContent,
  RequestApprovalContainerContentCardProductsContentColumn,
  RequestApprovalContainerContentCardProductsContentColumnDesc,
  RequestApprovalContainerContentCardProductsContentColumnImage,
  RequestApprovalContainerContentCardRequestApproval,
  RequestApprovalContainerContentCardRequestApprovalContent,
  RequestApprovalContainerContentCardRequestApprovalContentColumn,
  RequestApprovalContainerContentCardRequestApprovalContentColumnRow,
  RequestApprovalContainerContentCardResumoValue,
  RequestApprovalContainerContentCardResumoValueContent,
  RequestApprovalContainerContentCardResumoValueContentResume,
  RequestApprovalContainerContentCardShipping,
  RequestApprovalContainerContentCardShippingContent,
  RequestApprovalContainerContentCardShippingContentColumn,
  RequestApprovalContainerContentCardShippingContentColumnRow,
  RequestApprovalContainerContentCardTab,
  RequestApprovalContainerContentCardTabContent,
  RequestApprovalContainerContentCardTabContentTitle,
  RequestApprovalContainerContentResume,
  RequestApprovalContainerContentResumeContent,
} from "./styles";
import { Box } from "@chakra-ui/react";

class RequestedApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_request: this.props.data_request,
      all_request: this.props.all_request,
      company_select: this.props.company_select,
      data_client: this.props.data_client,
      data_delivery: this.props.data_delivery,
      data_product: this.props.data_product,
      total_value_billings: 0,
    };
  }

  componentDidMount() {
    var total_price = 0;
    this.state.all_request.map((data, idx) => {
      data.data_product.map((item) => {
        total_price = total_price + parseFloat(item.valor_total);
      });
      total_price =
        total_price +
        parseFloat(
          this.state.data_delivery.data_shipping.price
            .replace("R$", "")
            .replace(",", ".")
        );
    });

    this.setState({ total_value_billings: total_price });
  }

  render() {
    return (
      <Box>
        <RequestApprovalContainer>
          <TitleWithControl back={this.props.back}>
            <p>
              <strong>RESUMO DO SEU PEDIDO</strong> PARA APROVAÇÃO DO CLIENTE
            </p>
          </TitleWithControl>
          <Title>
            <p style={{ fontSize: "14px" }}>
              <strong>
                INNOVATION COMERCIO DE BRINDES CNPJ: 10635104000126 IS:
                148493416103
              </strong>
            </p>
          </Title>

          <RequestApprovalContainerContent>
            {this.state.all_request.map((data, idx) => {
              return (
                <CardProduct
                  request={data}
                  client={data.data_client}
                  delivery={this.state.data_delivery}
                  product={data.data_product}
                  num={idx + 1}
                  edit={this.props.edit}
                />
              );
            })}
          </RequestApprovalContainerContent>

          <ButtonContinue text={"Enviar para o cliente"} width={200}>
            <Resume value={this.state.total_value_billings} />
          </ButtonContinue>
        </RequestApprovalContainer>
      </Box>
    );
  }
}

function Resume(data) {
  return (
    <RequestApprovalContainerContentResume>
      <RequestApprovalContainerContentResumeContent>
        <p>
          TOTAL:{" "}
          <strong>
            {data.value.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </strong>
        </p>
      </RequestApprovalContainerContentResumeContent>
    </RequestApprovalContainerContentResume>
  );
}

function CardProduct(data) {
  const [open, setOpen] = useState(false);

  var total_price = 0;
  data.product.map((item) => {
    total_price = total_price + parseFloat(item.valor_total);
  });
  // console.log(data.delivery.data_shipping.price.replace('R\$ ',""));

  return (
    <RequestApprovalContainerContentCard
      style={
        open
          ? { transition: "0.3s" }
          : { transition: "0.3s", minHeight: "120px" }
      }
    >
      <RequestApprovalContainerContentCardTab>
        <RequestApprovalContainerContentCardTabContent>
          <RequestApprovalContainerContentCardTabContentTitle>
            <p>
              FATURAMENTO | <h1>{data.num}</h1>{" "}
              {data.request.razao_social_parceiro}
            </p>
          </RequestApprovalContainerContentCardTabContentTitle>
          <RequestApprovalContainerContentCardTabContentTitle>
            <p>
              ENTREGA | <h1>{data.num}</h1>{" "}
              {data.request.data_delivery.razao_social_parceiro}
            </p>
            <span
              onClick={() => setOpen(!open)}
              className={
                "icon icon-20 icon-arrow-" + (open ? "up" : "down") + "-white"
              }
            ></span>
          </RequestApprovalContainerContentCardTabContentTitle>
        </RequestApprovalContainerContentCardTabContent>
      </RequestApprovalContainerContentCardTab>
      <RequestApprovalContainerContentCardRequestApproval
        style={
          open
            ? { display: "flex", transition: "0.3s" }
            : { display: "none", transition: "0.3s" }
        }
      >
        <RequestApprovalContainerContentCardRequestApprovalContent>
          <RequestApprovalContainerContentCardRequestApprovalContentColumn>
            <RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
              <p>
                <strong>CNPJ</strong> {data.client.cpf_cnpj_parceiro}{" "}
                <strong>IE</strong> -
              </p>
              <ButtonEdit selectBilling={()=>data.edit(data.num)}/>
            </RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
            <RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
              <p>
                <strong>
                  {data.client.logradouro}, {data.client.numero},{" "}
                  {data.client.complemento} - {data.client.bairro},{" "}
                  {data.client.municipio} - {data.client.uf}, {data.client.cep}
                </strong>
              </p>
            </RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
          </RequestApprovalContainerContentCardRequestApprovalContentColumn>
          <RequestApprovalContainerContentCardRequestApprovalContentColumn>
            <RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
              <p>
                <strong>CNPJ</strong> {data.delivery.cpf_cnpj_parceiro}{" "}
                <strong>IE</strong> -
              </p>
              <ButtonEdit  selectBilling={()=>data.edit(data.num)}/>
            </RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
            <RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
              <p>
                <strong>
                  {data.delivery.logradouro}, {data.delivery.numero},{" "}
                  {data.delivery.complemento} - {data.delivery.bairro},{" "}
                  {data.delivery.municipio} - {data.delivery.uf},{" "}
                  {data.delivery.cep}
                </strong>
              </p>
            </RequestApprovalContainerContentCardRequestApprovalContentColumnRow>
          </RequestApprovalContainerContentCardRequestApprovalContentColumn>
        </RequestApprovalContainerContentCardRequestApprovalContent>
      </RequestApprovalContainerContentCardRequestApproval>
      {data.product.map((prod, idx) => {
        var img = "";
        if (prod.tipo_produto == "PROD") {
          var split_data = prod.url_seo.split("-");
          split_data.pop();
          var url = split_data.join("-");
          img =
            "https://innovationbrindes.com.br/images/produtos/" +
            prod.referencia.toString().substr(prod.referencia.length - 4) +
            "/" +
            url +
            "-1-1.jpg";
        } else {
          var img = "";
          data.product.map((emb) => {
            if (
              emb.tipo_produto == "PROD" &&
              emb.token_embalagem == prod.token_embalagem
            ) {
              img =
                "https://innovationbrindes.com.br/images/embalagem" +
                (emb.codigo_impressao_embalagem_selecionada
                  .descricao_impressao == "BOX PRINT"
                  ? emb.codigo_cor_embalagem_selecionada.imagem_box
                  : emb.codigo_impressao_embalagem_selecionada
                      .descricao_impressao == "LOCALIZADA"
                  ? emb.codigo_cor_embalagem_selecionada.imagem_print
                  : emb.codigo_cor_embalagem_selecionada.imagem_plus +
                    "plus/plus1.jpg");
            }
          });
        }

        return (
          <>
            <RequestApprovalContainerContentCardProducts
              style={
                open
                  ? { display: "flex", transition: "0.3s" }
                  : { display: "none", transition: "0.3s" }
              }
            >
              <RequestApprovalContainerContentCardProductsContent>
                <RequestApprovalContainerContentCardProductsContentColumn>
                  <RequestApprovalContainerContentCardProductsContentColumnImage>
                    <img alt='img' src={img} />
                  </RequestApprovalContainerContentCardProductsContentColumnImage>
                  <RequestApprovalContainerContentCardProductsContentColumnDesc>
                    <h1>
                      {prod.nome_produto.trim()} - {prod.referencia}
                    </h1>
                    <span className="icon icon-20 icon-pdf-orange"></span>
                    <p>Visualizar Layout</p>
                  </RequestApprovalContainerContentCardProductsContentColumnDesc>
                </RequestApprovalContainerContentCardProductsContentColumn>
                <RequestApprovalContainerContentCardProductsContentColumn>
                  {idx == 0 ? (
                    <p>
                      <strong>Saída da mercadoria:</strong> 11/11/2021
                    </p>
                  ) : (
                    <></>
                  )}
                </RequestApprovalContainerContentCardProductsContentColumn>
              </RequestApprovalContainerContentCardProductsContent>
            </RequestApprovalContainerContentCardProducts>
            <RequestApprovalContainerContentCardConfigProducts
              style={
                open
                  ? { display: "flex", transition: "0.3s" }
                  : { display: "none", transition: "0.3s" }
              }
            >
              <RequestApprovalContainerContentCardConfigProductsContent>
                <table>
                  <tbody>
                    <td>
                      <p>
                        Cor <strong>{prod.descricao_cor}</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        Gravação <strong>{prod.descricao_impressao}</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        Impressões <strong>{prod.qtd_batida}</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        Prazo de produção{" "}
                        <strong>{prod.id_prazo_entrega} dias úteis</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        Valor Unitario{" "}
                        <strong>
                          {parseFloat(prod.valor_unitario).toLocaleString(
                            "pt-BR",
                            { style: "currency", currency: "BRL" }
                          )}
                        </strong>
                      </p>
                      <p>
                        ST <strong className="pink">R$ 0,30</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        Quantidade{" "}
                        <strong>{parseInt(prod.qtd_negociada)}</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        Subtotal{" "}
                        <strong>
                          {parseFloat(prod.valor_total).toLocaleString(
                            "pt-BR",
                            { style: "currency", currency: "BRL" }
                          )}
                        </strong>
                      </p>
                      <p>
                        ST <strong className="pink">R$ 30,02</strong>
                      </p>
                    </td>
                  </tbody>
                </table>
              </RequestApprovalContainerContentCardConfigProductsContent>
            </RequestApprovalContainerContentCardConfigProducts>
          </>
        );
      })}

      {data.delivery.data_shipping != undefined ? (
        <>
          <RequestApprovalContainerContentCardShipping
            style={
              open
                ? { display: "flex", transition: "0.3s" }
                : { display: "none", transition: "0.3s" }
            }
          >
            <RequestApprovalContainerContentCardShippingContent>
              <RequestApprovalContainerContentCardShippingContentColumn>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    <strong>Transportadora: </strong>{" "}
                    {data.delivery.data_shipping.name}
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    <strong>Prazo Transportadora: </strong>{" "}
                    {data.delivery.data_shipping.prazo_producao} dias
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    <strong className="orange">
                      OBSERVAÇÕES DADOS ADICIONAIS:{" "}
                    </strong>{" "}
                    Colocar número do pedido 02032. Solicitante Silvia.
                    Departamento de Marketing.
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
              </RequestApprovalContainerContentCardShippingContentColumn>
              <RequestApprovalContainerContentCardShippingContentColumn>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    Valor total Produto:{" "}
                    <strong>
                      {parseFloat(total_price).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </strong>
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    Total ST: <strong>R$ 0,00</strong>
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    Valor total Frete:{" "}
                    <strong>{data.delivery.data_shipping.price}</strong>
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
                <RequestApprovalContainerContentCardShippingContentColumnRow>
                  <p>
                    Manuseio: <strong>R$ 0,00</strong>
                  </p>
                </RequestApprovalContainerContentCardShippingContentColumnRow>
              </RequestApprovalContainerContentCardShippingContentColumn>
            </RequestApprovalContainerContentCardShippingContent>
          </RequestApprovalContainerContentCardShipping>
          <RequestApprovalContainerContentCardResumoValue>
            <RequestApprovalContainerContentCardResumoValueContent>
              <RequestApprovalContainerContentCardResumoValueContentResume>
                <span className="line"></span>
                {data.delivery.data_shipping.price != undefined ? (
                  <h1>
                    TOTAL:{" "}
                    <strong>
                      {(
                        parseFloat(total_price) +
                        parseFloat(
                          data.delivery.data_shipping.price
                            .replace("R$", "")
                            .replace(",", ".")
                        )
                      ).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </strong>
                  </h1>
                ) : (
                  <></>
                )}
              </RequestApprovalContainerContentCardResumoValueContentResume>
            </RequestApprovalContainerContentCardResumoValueContent>
          </RequestApprovalContainerContentCardResumoValue>
        </>
      ) : (
        <></>
      )}
    </RequestApprovalContainerContentCard>
  );
}

export default RequestedApproval;
